import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const DEFAULT_DESCRIPTION =
  "Write, share, and play choose your own adventure stories. Build branching narratives with our visual story editor or import a spreadsheet on Pick Your End.";
export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  noindex,
  type = "website",
}) {
  const { pathname } = useLocation();
  useEffect(() => {
    const origin = (
      process.env.REACT_APP_SITE_URL || window.location.origin
    ).replace(/\/$/, "");
    const url = origin + (pathname === "/intro" ? "/" : pathname);
    const pageTitle = title
      ? `${title} | Pick Your End`
      : "Pick Your End — Every choice begins a story";
    document.title = pageTitle;
    const meta = (key, content, property = false) => {
      const attr = property ? "property" : "name";
      let element = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attr, key);
        document.head.appendChild(element);
      }
      element.content = content;
    };
    meta("description", description);
    meta("robots", noindex ? "noindex, nofollow" : "index, follow");
    meta("og:title", pageTitle, true);
    meta("og:description", description, true);
    meta("og:url", url, true);
    meta("og:type", type, true);
    meta("og:image", `${origin}/social-card.png`, true);
    meta("twitter:card", "summary_large_image");
    meta("twitter:title", pageTitle);
    meta("twitter:description", description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;
    document.head
      .querySelectorAll('script[type="application/ld+json"]')
      .forEach((element) => element.remove());
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": type === "article" ? "CreativeWork" : "WebSite",
      name: title || "Pick Your End",
      description,
      url,
    });
    document.head.appendChild(script);
    return () => script.remove();
  }, [title, description, noindex, type, pathname]);
  return null;
}
